<template>
  <div class="content">
    
      <img src="/static/images/NEW_CCO_LOGO.svg" id="logo" alt="Coding Class Odense" />
    
<!--
    <hr
      style="margin:30px auto; border-bottom:0; width:80%; border-left:0; border-right:0; border-top: 2px solid #c0c0c0;" />
    <h1>Velkommen til Coding Class Odense!</h1>
    <p>
      Coding Class Odense er et 4-dages undervisningsforløb i kodning, der
      tilbydes til alle 6. klasser i Odense. <br />

      
      <strong
        style="font-size: 22px; display: block; margin-bottom: 5px; font-weight: normal;"
        >Undervisere offline såvel som online:</strong
      ><br />
      <img
        src="/static/images/cco_undervisere.svg"
        style="width: 700px; margin: 0 auto; display: block;"
        alt=""
      />
      
      <strong
        style="font-size: 22px; margin-top: 20px; display: block; font-weight: normal;">Start
        forløbet ved at gå ind på
        <router-link to="/online-undervisning">Coding Class-forløb</router-link>
      </strong>
    
      <strong
        style="font-size: 22px; margin-top: 20px; margin-bottom: 100px; display: block; font-weight: normal;">Insend spil til Coding Class finalen 2024:
        <router-link to="/next-finale">Tryk her</router-link>
      </strong>-->
    </p>
  </div>
</template>

<script>
export default {
  name: "Index"
};
</script>

<style>
p {
  font-size: 18px;
  line-height: 25px;
}

#logo {
  width: 500px;
  max-width: 80%;
  display: block;
  margin: 40px auto;
}

a #logo {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue